// Flatten the customer saved on a bill (Nyafaz profile copied into metadata) for display.

function readableService(name) {
  const raw = String(name || '').trim();
  return raw && !/^(organization_id|visit_organization_id|franchise_id|franchise_code|latitude|longitude)\b/i.test(raw);
}

export function locationLabel(loc) {
  if (!loc) return null;
  if (typeof loc === 'string') return loc.trim() || null;
  if (typeof loc !== 'object') return null;
  const name = loc.name || loc.franchise_name || '';
  const place = [loc.area, loc.city, loc.state].map((p) => (p ? String(p).trim() : '')).filter(Boolean).join(', ');
  if (name && place) return `${name} · ${place}`;
  return name || place || null;
}

export function customerView(bill) {
  const c = bill?.customer;
  if (!c) return null;
  const meta = c.metadata || {};
  const prefs = meta.preferences || {};
  const membership = meta.membership || c.membership || {};
  const previous = (c.previous_services?.length ? c.previous_services : meta.previous_services || [])
    .map((s) => ({ ...s, service_name: s.service_name || s.name }))
    .filter((s) => readableService(s.service_name));
  return {
    name: c.name || 'Guest',
    phone: c.phone || '',
    nyafazId: c.external_ref || c.face_ref || null,
    fromNyafaz: Boolean(c.external_ref || c.face_ref),
    source: meta.provider || null,
    tier: c.membership_tier && c.membership_tier !== 'none' ? c.membership_tier : membership.tier || 'none',
    memberId: membership.member_id || null,
    points: membership.points ?? null,
    planId: c.plan_id || meta.plan_id || prefs.customer_first_plan_id || null,
    planCredit: c.plan_credit_limit ?? meta.plan_credit_limit ?? null,
    gender: c.gender || meta.gender || null,
    age: c.age ?? meta.age ?? null,
    dob: c.date_of_birth || meta.date_of_birth || null,
    anniversary: c.anniversary_date || meta.anniversary_date || null,
    visits: c.visit_count ?? meta.visit_count ?? null,
    lastVisit: c.last_visit_location_label || meta.last_visit_location_label || locationLabel(meta.last_visit_location),
    allergies: (c.allergies || meta.allergies || []).map((a) => (typeof a === 'string' ? a : a?.label)).filter(Boolean),
    previousServices: previous,
    treatments: c.previous_treatments || meta.previous_treatments || [],
    products: c.products_purchased || meta.products_purchased || [],
  };
}
